import PropTypes from "prop-types"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import SetPassword from "modules/set-password"

export default function ActivateAccount({ token, name, email, ssoActivationToken, setLoginError }) {
  const navigate = useNavigate()

  useEffect(() => {
    if (!token && !ssoActivationToken) {
      setLoginError("Your token is expired. Please login normally or click the Forgot Password link if you need to reset it.")
      navigate("/")
    }
  })

  useEffect(() => {
    if (ssoActivationToken) {
      window.location = `/activate-sso-account/${ssoActivationToken}`
    }
  }, [ssoActivationToken])

  return <SetPassword
    title={`Welcome, ${name}!`}
    text="Complete the activation of your account here"
    subText={email}
    buttonText="Activate Account"
    token={token}
    userActivation
  />
}

ActivateAccount.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  token: PropTypes.string,
  ssoActivationToken: PropTypes.string,
  setLoginError: PropTypes.func.isRequired,
}
